import { SET_COPIED_SHIPMENT, CLEAR_COPIED_SHIPMENT, SET_COPIED_SHIPMENT_STATUS } from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  init: false,
  status: statuses.idle
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_COPIED_SHIPMENT:
      const newShipment = { ...action.payload };
      delete newShipment.id;
      delete newShipment.uid;
      delete newShipment.files;

      return {
        ...state,
        ...newShipment,
        status: statuses.succeeded
      };
    case SET_COPIED_SHIPMENT_STATUS:
      const { status, init } = action.payload;
      return { ...state, status, init };
    case CLEAR_COPIED_SHIPMENT:
      return defaultState;
    default:
      return state;
  }
};
